import { observable, IObservableArray, makeObservable } from 'mobx';

import { optional } from '@vromo/models';

import { BrandColors } from '@vromo/models';
import { BrandPromotion } from '@vromo/models';

import { TrackingLinkPolicy } from '@vromo/models';

import { Upload } from '@vromo/models';
import { Widget } from '@vromo/models';

import { createModelSchema, primitive, raw, object } from 'serializr';

class CampaignAnalytics {
    google?: string | null = null;

    constructor() {
        makeObservable(this, {
            google: observable
        });
    }
}

createModelSchema(CampaignAnalytics, {
    google: optional(primitive())
});

export class Campaign {
    id?: number;
    created?: number;
    name?: string;
    displayOrderDetails?: boolean;
    /** company logo */
    logo?: Upload;
    theme?: BrandColors;
    promotion?: BrandPromotion;
    link?: TrackingLinkPolicy;
    widgets?: IObservableArray<Widget>;
    /** google analitycs tracking code */
    analytics?: CampaignAnalytics;

    constructor(id?: number) {
        makeObservable(this, {
            id: observable,
            name: observable,
            displayOrderDetails: observable,
            logo: observable,
            theme: observable,
            promotion: observable,
            link: observable,
            widgets: observable,
            analytics: observable
        });

        if (id) this.id = id;
    }
}

createModelSchema(Campaign, {
    id: primitive(),
    created: primitive(),
    name: primitive(),
    displayOrderDetails: primitive(),
    logo: object(Upload),
    theme: object(BrandColors),
    promotion: object(BrandPromotion),
    link: object(TrackingLinkPolicy),
    widgets: raw(),
    analytics: object(CampaignAnalytics)
});
